<template>
  <!-- 提货指令列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="addModifyBtns({}, 0)"
          v-permission="'admin:waibill:commands:add'"
          >新建订单</el-button
        >
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="receiveOrder()"
          v-permission="'admin:waibill:commands:add'"
          >接单确认</el-button
        >
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="receiveOutgoing()"
          v-permission="'admin:waibill:commands:add'"
          >接单并外发</el-button
        >
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="changeWaybill"
          :disabled="!single"
          v-permission="'admin:waibill:commands:transform'"
          >转为运单</el-button
        >
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          :disabled="!single"
          @click="changeSomeWaybill"
          v-permission="'admin:waibill:commands:transform:part'"
          >部分转为运单</el-button
        >
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="cancelOrder"
          :disabled="!selected"
          v-permission="'admin:waibill:commands:cancel'"
          >取消订单</el-button
        >
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="distributeEmployee"
          :disabled="!selected"
          v-permission="'admin:waibill:commands:distribute:emp'"
          >分配收件员</el-button
        >
        <!-- <el-button class="glo_btnItems" @click="delBtns({})"
          >批量删除</el-button
        > -->
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <!-- <el-dropdown-item command="printBtns">打印</el-dropdown-item> -->
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :fieldList="fieldList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      row-key='commandNumber'
      @fildsClick="fildsClick"
      @OperateFn="OperateFn"
      @handleCommandBtns="handleCommandBtns"
      @handleSelectionChange="handleSelectionChange"
    ></mytable>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 导出 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>

    <!-- 打印 -->
    <!-- <prints
      :dialogVisible="dialogVisible"
      :ShowClassNameDialog="ShowClassNameDialog"
      :classNameArrList="classNameArr"
      :dfClassName="modelClassName"
    ></prints> -->
    <myDialog
      diaWidth="330px"
      dialogTitle="选择收件员"
      :isShowDialog="showEmployee"
      @handleCloseDia="handleClose"
      @diaCancelBtn="handleClose"
      @diaConfirmBtn="chooseEmployee"
    >
      <el-form label-position="left" label-width="100px">
        <el-form-item label="收件员：">
          <el-select
            v-model="allocationStaffForm.selectedEmployeeId"
            placeholder="请选择"
            filterable
            remote
            :remote-method="getEmps"
            @focus="getEmps()"
          >
            <el-option
              v-for="emp in emps"
              :key="emp.employeeId"
              :label="emp.jobNumber"
              :value="emp.employeeId"
            >
              <span style="float: left">{{ emp.jobNumber }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                emp.employeeName
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接单网点：">
          <dept-tree
            v-model="allocationStaffForm.receiveOrderDeptId"
            :height="37"
            :multiple="false"
            :checkStrictly="true"
            :is-storage="1"
          ></dept-tree>
        </el-form-item>
        <el-form-item label="开单网点：">
          <dept-tree
            v-model="allocationStaffForm.openOrderDeptId"
            :height="37"
            :multiple="false"
            :checkStrictly="true"
            :is-storage="1"
          ></dept-tree>
        </el-form-item>
      </el-form>
    </myDialog>
    <myDialog
      diaWidth="330px"
      dialogTitle="接单确认"
      :isShowDialog="showReceiveOrderDialog"
      @handleCloseDia="handleCloseReceiveOrderDialog"
      @diaCancelBtn="handleCloseReceiveOrderDialog"
      @diaConfirmBtn="justDoReceiveOrder"
    >
      <el-form label-position="left" label-width="100px">
        <el-form-item label="接单网点：">
          <dept-tree
            v-model="receiveOrderForm.receiveOrderDeptId"
            :height="37"
            :multiple="false"
            :checkStrictly="true"
            :is-storage="1"
          ></dept-tree>
        </el-form-item>
        <el-form-item label="开单网点：">
          <dept-tree
            v-model="receiveOrderForm.openOrderDeptId"
            :height="37"
            :multiple="false"
            :checkStrictly="true"
            :is-storage="1"
          ></dept-tree>
        </el-form-item>
      </el-form>
    </myDialog>
    <myDialog
      diaWidth="330px"
      dialogTitle="接单并外发"
      :isShowDialog="showReceiveOutgoingDialog"
      @handleCloseDia="handleCloseReceiveOutgoingDialog"
      @diaCancelBtn="handleCloseReceiveOutgoingDialog"
      @diaConfirmBtn="justDoReceiveOutgoing"
    >
      <el-form label-position="left" label-width="100px">
        <el-form-item label="接单网点：">
          <dept-tree
            v-model="receiveOutgoingForm.receiveOrderDeptId"
            :height="37"
            :multiple="false"
            :checkStrictly="true"
            :is-storage="1"
          ></dept-tree>
        </el-form-item>
        <el-form-item label="外发承运商：">
          <el-select
            v-model="receiveOutgoingForm.carrierId"
            filterable
            remote
            :remote-method="getCarriers"
            @focus="getCarriers()"
          >
            <el-option
              v-for="carrier in carriers"
              :key="carrier.carrierId"
              :label="carrier.carrierName"
              :value="carrier.carrierId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </myDialog>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/Dialog.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import mytable from "@/components/table/VrTable.vue";
// import prints from "@/components/prints/printPage.vue";
export default {
  mixins: [tableListNew, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    mytable,
    myDialog,
    // prints,
  },
  data() {
    return {
      pageGroupName: "BusinessOrder_WaybillManage_NewPickupInstruction", //  页面标识(设置自定义表头用到,自定义的唯一标记)
      reportFiledsNumber: "admin_command_list_v5", // 动态 条件、表头
      // ************************* 表格相关 strat *************************
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "addModifyBtns", //当前页面的方法
          param: 1, //自定义参数标记,
          permission: "admin:waibill:commands:edit",
        },
        // {
        //   name: "删除",
        //   methods: "delBtns",
        //   param: "",
        // },
        {
          name: "详情",
          methods: "addModifyBtns",
          param: 2,
          permission: "admin:waibill:commands:detail",
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
        // {
        //   name: "按钮A",
        //   command: "a",
        // },
        // {
        //   name: "按钮B",
        //   command: "b",
        // },
      ],
      //需要单独点击的列字段名数组
      fieldList: this.hasPermiss("edit") ? ["commandNumber"] : [],
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      Operatewidth: "220px", //操作列的列宽
      // ************************* 表格相关 end *************************

      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "提货指令列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json 1==是 0==否
      },
      //=======================导出相关 结束 =======================

      // ++++++++++++++++++++++++ 打印 ++++++++++++++++++++++++
      // 旧版的,新的应该换成动态接口
      dialogVisible: false,
      ShowClassNameDialog: false,
      //当前页面所有的打印类型
      classNameArr: [],
      // 默认的模板类型 (获取打印字段的接口getPrintFields需要用到className,)
      modelClassName: "",
      // ++++++++++++++++++++++++ 打印 ++++++++++++++++++++++++
      showEmployee: false,
      selectedEmployeeId: "",
      emps: [],
      showReceiveOrderDialog: false,
      receiveOrderForm: {
        receiveOrderDeptId: "",
        openOrderDeptId: "",
      },
      showReceiveOutgoingDialog: false,
      receiveOutgoingForm: {
        receiveOrderDeptId: "",
        carrierId: "",
      },
      carriers: [],
      allocationStaffForm: {
        selectedEmployeeId: "",
        receiveOrderDeptId: "",
        openOrderDeptId: "",
      },
    };
  },
  mounted() {},
  watch: {},
  computed: {
    multi() {
      return this.selectTableData.length > 1;
    },
    single() {
      return this.selectTableData.length == 1;
    },
    selected() {
      return this.selectTableData.length > 0;
    },
  },
  methods: {
    async getCarriers(carrierName) {
      const number = "down_list_carrier";
      const res = await this.$API.runList({
        number,
        carrierName,
      });
      this.carriers = res;
    },
    receiveOrder() {
      if (this.selectTableData.length === 0) {
        this.$message.error("请至少选择一条数据进行操作");
        return;
      }
      if(!this.receiveOrderForm.receiveOrderDeptId)
        this.receiveOrderForm.receiveOrderDeptId = this.$TOOLS.getUserInfo().departmentId;
      this.showReceiveOrderDialog = true;
    },
    async justDoReceiveOrder() {
      const commandIds = this.selectTableData.map((item) => item.commandId);
      await this.$API.receiveOrder({
        commandIds,
        receiveOrderDeptId: this.receiveOrderForm.receiveOrderDeptId,
        openOrderDeptId: this.receiveOrderForm.openOrderDeptId,
      });
      this.$message.success("操作成功");
      this.getData();
      this.handleCloseReceiveOrderDialog();
    },

    handleCloseReceiveOrderDialog() {
      this.showReceiveOrderDialog = false;
      this.receiveOrderForm = {};
    },

    receiveOutgoing() {
      if (this.selectTableData.length === 0) {
        this.$message.error("请至少选择一条数据进行操作");
        return;
      }
      this.showReceiveOutgoingDialog = true;
    },
    async justDoReceiveOutgoing() {
      const commandIds = this.selectTableData.map((item) => item.commandId);
      await this.$API.receiveOrderToOutgoing({
        commandIds,
        receiveOrderDeptId: this.receiveOutgoingForm.receiveOrderDeptId,
        carrierId: this.receiveOutgoingForm.carrierId,
      });
      this.$message.success("操作成功");
      this.handleCloseReceiveOutgoingDialog();
      this.getData();
    },
    handleCloseReceiveOutgoingDialog() {
      this.showReceiveOutgoingDialog = false;
      this.receiveOutgoingForm = {};
    },
    // 操作按钮回调  fn==按钮方法名称,data==这行数据,type==自定义的一个参数
    OperateFn(data, fn, type) {
      // this.addModifyBtns(data,type)
      this[fn](data, type);
    },
    // 更多操作按钮回调
    handleCommandBtns(command, data) {
      console.log(command, data);
      if (command == "a") {
        console.log("点击了按钮A");
      }
    },
    // 点击指定列
    fildsClick(data, field) {
      if (field == "commandNumber") {
        this.addModifyBtns(data, 2);
      }
    },

    handleSelectionChange(rows) {
      this.selectTableData = rows;
    },

    // 打印
    printEvent(row) {
      if (this.selectTableData.length < 1) {
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.ShowClassNameDialog = true;
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        // 打印接口要什么id这里就拿什么id
        let idarr = this.selectTableData.map((item) => {
          return item.id;
        });
        window.sessionStorage.setItem(
          "set_PrintSelectTableData",
          JSON.stringify(idarr)
        );
        this.dialogVisible = true;
      }
    },

    // 新增、 修改 、查看
    addModifyBtns({ commandId }, type) {
      console.log("修改 commandId", commandId, type);
      let query = {};
      switch (type) {
        case 1:
          query.commandId = commandId;
          this.$router.push({
            path: "/WaybillManage/NewPickupInstructionEdit",
            query,
          });
          return;
        case 2:
          query.isSee = 1;
          query.commandId = commandId;
          this.$router.push({
            path: "/WaybillManage/NewPickupInstructionDetail",
            query,
          });
          return;
      }
      this.$router.push({
        path: "/WaybillManage/NewPickupInstructionAddEdit",
        query,
      });
    },
    // 删除
    delBtns({ commandId }) {
      let ids = [];
      if (commandId) {
        ids = [commandId];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请至少选择一条数据进行操作");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.commandId);
        });
      }
      this.$confirm("确定要删除所选提货单吗? 请谨慎操作", "提示:")
        .then((res) => {
          this.$API.commanddelCommand({ commandIds: ids }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch((err) => {});
    },
    changeWaybill() {
      if (this.selectTableData.length === 0) {
        this.$message.error("请至少选择一条数据进行操作");
        return;
      }
      const firstOne = this.selectTableData[0];
      let customer = firstOne.customerId;
      let provinceName = firstOne.receiveProvinceName;
      let cityName = firstOne.receiveCityName;
      let areaName = firstOne.receiveAreaName;
      let address = firstOne.receiveAddress;
      for (let item of this.selectTableData) {
        if (item.customerId !== customer) {
          this.$message.error("开单客户不一致");
          return;
        }
        if (
          item.receiveProvinceName !== provinceName ||
          item.receiveCityName !== cityName ||
          item.receiveAreaName !== areaName ||
          item.receiveAddress !== address
        ) {
          this.$message.error("收货地址不一致");
          return;
        }
      }
      const commandIds = this.selectTableData.map((item) => item.commandId);
      this.$router.push({
        path: "/WaybillManage/WaybillTranformRX",
        query: {
          commandIds: JSON.stringify(commandIds),
        },
      });
    },
    changeSomeWaybill() {
      if (this.selectTableData.length === 0) {
        this.$message.error("请至少选择一条数据进行操作");
        return;
      }
      const firstOne = this.selectTableData[0];
      let customer = firstOne.customerId;
      let provinceName = firstOne.receiveProvinceName;
      let cityName = firstOne.receiveCityName;
      let areaName = firstOne.receiveAreaName;
      let address = firstOne.receiveAddress;
      for (let item of this.selectTableData) {
        if (item.customerId !== customer) {
          this.$message.error("开单客户不一致");
          return;
        }
        if (
          item.receiveProvinceName !== provinceName ||
          item.receiveCityName !== cityName ||
          item.receiveAreaName !== areaName ||
          item.receiveAddress !== address
        ) {
          this.$message.error("收货地址不一致");
          return;
        }
      }
      const commandIds = this.selectTableData.map((item) => item.commandId);
      this.$router.push({
        path: "/WaybillManage/WaybillTranformRX",
        query: {
          commandIds: JSON.stringify(commandIds),
        },
      });
    },
    cancelOrder() {
      const commandIds = this.selectTableData.map((item) => item.commandId);
      this.$confirm("确定取消选中订单？", "警告")
        .then(() => {
          this.$API
            .commandCancelCommand({
              commandIds,
            })
            .then((res) => {
              this.$message.success(res.data.message || "取消成功");
              this.getData();
            });
        })
        .catch((err) => {});
    },
    async distributeEmployee() {
      if (this.emps.length == 0) {
        await this.getEmps();
      }
      this.selectedEmployeeId = null;

      if (this.selectTableData.length > 0) {
        let receiveOrderDeptId = this.selectTableData[0].receiveOrderDeptId;
        let openOrderDeptId = this.selectTableData[0].openOrderDeptId;
        let allAValuesSame = true;
        this.selectTableData.forEach((item) => {
          if (
            item.receiveOrderDeptId !== receiveOrderDeptId ||
            item.openOrderDeptId !== openOrderDeptId
          ) {
            allAValuesSame = false;
          }
        });
        console.log("allAValuesSame", allAValuesSame);
        if (!allAValuesSame) {
          this.$message.error("请选择 同一接单网点 和 同一开单网点 下的订单");
          return false;
        }
        this.allocationStaffForm.receiveOrderDeptId = receiveOrderDeptId;
        this.allocationStaffForm.openOrderDeptId = openOrderDeptId;

        this.showEmployee = true;
      }
    },
    handleClose() {
      this.showEmployee = false;
      this.allocationStaffForm = {};
    },
    async chooseEmployee() {
      const commandIds = this.selectTableData.map((item) => item.commandId);
      const employeeId = this.allocationStaffForm.selectedEmployeeId;
      const res = await this.$API.commandAllocationStaff({
        commandIds,
        employeeId,
        receiveOrderDeptId: this.allocationStaffForm.receiveOrderDeptId,
        openOrderDeptId: this.allocationStaffForm.openOrderDeptId,
      });
      this.$message.success("收件员分配成功");
      this.getData();
      this.selectedEmployeeId = null;
      this.handleClose();
    },
    async getEmps(employeeName) {
      const res = await this.$API.runList({
        number: "down_list_employee",
        employeeName,
      });
      this.emps = res;
    },
  },
};
</script>
<style scoped lang="less">
</style>
